export const signUpEvent = {
  openPage: 'sign_up/open_page',
  clickButton: 'sign_up/click_button',
  getResponse: 'sign_up/get_response'
};
